/**
 * `zoom-out` glyph (Untitled UI). A magnifier with a minus, paired
 * with {@link ZoomInGlyph}. Uses `currentColor` so the enclosing
 * button controls tinting.
 *
 * Geometry matches the Figma zoom control (node `16844:35662`):
 * circle radius 8 centred at (11, 11), handle to (21, 21), and a
 * centred minus.
 */
export type ZoomOutGlyphProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function ZoomOutGlyph({ size = 24, className }: ZoomOutGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ZoomOutGlyph;
